module.exports = __webpack_public_path__ + "static/media/layout-fill.3926ed2c.svg";